import type { SVGProps } from 'react';

const CodexIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="3" />
    <path d="M9 8 5 12l4 4" />
    <path d="m15 8 4 4-4 4" />
    <path d="m13 6-2 12" />
  </svg>
);

export { CodexIcon };
